<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">
 						<h4 class="mb-3 card-ttl">アカウント詳細</h4>	
					
                          <div>
                              <div class="form-group">
                                  <label>会社名 </label>
                                  <span>{{ userDetails.personal_company_name }}</span>
                              </div>
							   <div class="form-group">
                                  <label>メールアドレス</label>
                                  <span>{{ userDetails.email }}</span>
                              </div>

                               <div class="form-group">
                                  <label>名前</label>
                                  <span>{{ userDetails.name }}</span>
                              </div>

                              </div>
							  <div class="form-group">
                                  <label>部署</label>
                                  <span>{{ userDetails.dept }}</span>
                              </div>
							  <div class="form-group">
                                  <label>役職</label>
                                  <span>{{ userDetails.designation }}</span>
                              </div>
                               <div class="form-group">
                                  <label>電話番号</label>
                                  <span>{{ userDetails.designation }}</span>
                              </div>

							  <div class="form-group">
                                  <label>住所</label>
                  <span>{{ userDetails.zip_code }}{{ userDetails.state }}{{ userDetails.city }}{{ userDetails.address_1 }}</span>
							  </div>
                   <div class="form-group">
                                  <label>登録サイト</label>
                                  <div>
                                    <table class="site-list-tbl">
                                      <thead>
                                        <tr>
                                          <th class="text-center"><span>サイト名</span></th>
                                          <th class="text-center"><span>ドメイン</span></th>
                                          <th class="text-center"><span>契約プラン</span></th>
                                          <th class="text-center"><span>契約日</span></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="site in siteData" :key="site.id" class="el-table__row">
										                   <td class=""><span> {{ site.site_name_jp }} </span></td>
                                       <td class=""><span>{{ site.site_domain }}</span></td>
                                       <th class="text-center"><span>{{ getPlan(site.id) }}</span></th>
                                       <th class="text-center"><span>{{ getcontractDate(site.id) }}</span></th>
                                       
                                        </tr>

                                        
                                      </tbody>


                                    </table>
                                  </div>

                              </div>
                              
							      
<!--
							   会社名　アドレス　名前　部署　役職　電話番号　住所の変更ができる

							  "created_at":"2021-05-18T11:40:16.000000Z","updated_at":"2021-05-18T11:42:23.000000Z","company_id":1,"username":"","designation":"","is_active":1,"sys_admin":0,"first_name":"","last_name":"","dept":"","phone":""}

-->
							    <div class="btn-wrap form-group text-center">
									<a class="btn btn-primary btn-white" :href="'/users/' + siteId + '/list'">一覧に戻る</a>
									<a class="btn btn-primary" :href="'/users/' + userDetails.id + '/edit' " v-show="permission_list['user-edit'] && userDetails.editable ? true:false" >編集</a>
									<button class="delete-btn btn btn-primary btn-cancel" @click="doDelete(userDetails.id)" v-show="permission_list['user-delete'] && userDetails.deleteable ? true:false" >削除</button>
									<confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                              </div>
                          </div>
					</div>
                </div>
            </div>
			
		</div>
	
</template>

<script>
import ConfirmDialogue from './ConfirmDialogue.vue'
export default {
  components: {
    ConfirmDialogue
  },
  
	props: ['UserData', 'siteList', 'SiteContract'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
      userDetails: {},
      siteData:{},
      siteId:null,
      //selectedSitesInfo:{},
      siteContract:{}
		}
	},
    computed: {
  		 
    },
	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;
    this.userDetails = JSON.parse(this.UserData);
    this.siteData = JSON.parse(this.siteList);
    //this.selectedSitesInfo = JSON.parse(this.userSite);	
    this.siteContract = JSON.parse(this.SiteContract);
    console.log(this.userDetails)
	},

	methods: {
    getPlan(siteId) {
      for (let i=0;i<this.siteContract.length;i++) {
        if(this.siteContract[i].site_id== siteId) {
          return this.siteContract[i].title;
        }
      }
    },
    getcontractDate(siteId) {
      for (let i=0;i<this.siteContract.length;i++) {
        if(this.siteContract[i].site_id== siteId) {
          return this.siteContract[i].contract_date;
        }
      }
    },
		// Our method to GET results from a Laravel endpoint
		async doDelete(id) {
      var confirmDialog = this.$refs.confirmDialogue;
      const ok = await confirmDialog.show({
          title: 'ユーザ一を削除',
          message: 'ユーザ一を削除しますか？',
          okButton: 'はい',
          cancelButton: 'いいえ'
      })
      // If you throw an error, the method will terminate here unless you surround it wil try/catch
      try {
        if (ok) {
            this.deleteUser(id);
        } 
      }
      catch(error){

      }
		},
		deleteUser(id) {
          this.loading = true;
      this.errors = {};
      this.error = false;
      axios.post('/users/' + id , {
		  '_method':'DELETE',
      		id:id
      	}).then(response => {
       // this.loading = false;
        //this.info = response.data.info;
         this.categories = response.data.result;
         this.$toast("削除しました", {
            //timeout: false,
            toastClassName: "toaster",
            onClose: () => {
              window.location.href = "/users/" + this.siteId + "/list"
            },
        });
        //this.id = response.data.result.id;
      }).catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
          //this.info = error.response.data.info;
          this.$toast(error.response.data.info, {
			      toastClassName: "toaster error"
          })
          this.error = true;
           this.loading = false;
        } else if (error.response.status === 419) {
          alert("ページセッション切りましたので、削除できませんでした。ページをリロードしてください")
        }
      });
        }
	}

}
</script>

<style scoped>
/*.delete-btn{
  padding:0;
  color:#5e72e4;
  font-weight:700;
}
.delete-btn:focus,
.delete-btn:hover {
  box-shadow:none;
  text-decoration:underline;
 
}*/
h4 { margin-bottom:20px}

.form-group {
  margin-bottom:1rem;
}
.form-group label {
  font-weight:bold;
}
.form-group label,
.form-group span
 {
  font-size:14px;
  line-height:24px;
}
.form-group span {
  display:block;
  padding:5px 0 5px 20px;
  color: #757575;
}

.site-list-tbl {
    margin-left: 20px;
}
.site-list-tbl span {
  padding:  5px 12px; 
}
.site-list-tbl thead {
background-color: #EAEAEA;
}
.site-list-tbl td, .site-list-tbl th {
  border:1px solid #EAEAEA

}
</style>